/**
 * <bp-gallery-filters> Web Component
 * Handles tag filtering and load-more for the gallery grid.
 */
class BpGalleryFilters extends HTMLElement {
  constructor() {
    super();
    this.activeFilter = 'all';
    this.batchSize = 6;
    this.visibleCount = 0;
  }

  connectedCallback() {
    this.tabs = this.querySelector('.bp-gallery__filter-tabs');
    this.grid = this.querySelector('.bp-gallery__grid');
    this.loadMoreBtn = this.querySelector('.bp-gallery__load-more-btn');
    this.items = Array.from(this.grid.querySelectorAll('.bp-gallery__item'));

    this.buildTabs();
    this.tabs.addEventListener('click', this.handleTabClick.bind(this));

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener(
        'click',
        this.handleLoadMore.bind(this)
      );
    }

    this.applyFilter();
  }

  buildTabs() {
    const tagSet = new Set();
    this.items.forEach((item) => {
      const tags = item.dataset.tags;
      if (tags) {
        tags.split(',').forEach((t) => tagSet.add(t.trim()));
      }
    });

    const fragment = document.createDocumentFragment();

    const allBtn = document.createElement('button');
    allBtn.className = 'bp-gallery__filter-tab bp-gallery__filter-tab--active';
    allBtn.type = 'button';
    allBtn.textContent = 'All';
    allBtn.dataset.filter = 'all';
    fragment.appendChild(allBtn);

    tagSet.forEach((tag) => {
      const btn = document.createElement('button');
      btn.className = 'bp-gallery__filter-tab';
      btn.type = 'button';
      btn.textContent = tag;
      btn.dataset.filter = tag.toLowerCase();
      fragment.appendChild(btn);
    });

    this.tabs.appendChild(fragment);
  }

  handleTabClick(e) {
    const tab = e.target.closest('.bp-gallery__filter-tab');
    if (!tab) return;

    this.tabs
      .querySelectorAll('.bp-gallery__filter-tab')
      .forEach((t) => t.classList.remove('bp-gallery__filter-tab--active'));
    tab.classList.add('bp-gallery__filter-tab--active');

    this.activeFilter = tab.dataset.filter;
    this.applyFilter();
  }

  applyFilter() {
    let matchingItems = [];

    this.items.forEach((item) => {
      const tags = (item.dataset.tags || '').toLowerCase();
      const matches =
        this.activeFilter === 'all' ||
        tags.split(',').some((t) => t.trim() === this.activeFilter);

      if (matches) {
        matchingItems.push(item);
      }
      item.style.display = 'none';
    });

    this.visibleCount = Math.min(this.batchSize, matchingItems.length);

    for (let i = 0; i < this.visibleCount; i++) {
      matchingItems[i].style.display = '';
    }

    this.matchingItems = matchingItems;
    this.updateLoadMore();
  }

  handleLoadMore(e) {
    e.preventDefault();
    const nextCount = Math.min(
      this.visibleCount + this.batchSize,
      this.matchingItems.length
    );

    for (let i = this.visibleCount; i < nextCount; i++) {
      this.matchingItems[i].style.display = '';
    }

    this.visibleCount = nextCount;
    this.updateLoadMore();
  }

  updateLoadMore() {
    if (!this.loadMoreBtn) return;
    this.loadMoreBtn.style.display =
      this.visibleCount >= this.matchingItems.length ? 'none' : '';
  }
}

customElements.define('bp-gallery-filters', BpGalleryFilters);
